<template>
  <div class="orderRenewal-batchUpload">
    <QS-scroller-box>
      <div>
        <p class="title">方式：批量导入</p>
        <div class="btns">
          <el-button
            class="download-template"
            type="text"
            @click="handleDownloadTemplate"
            >下载导入模板</el-button
          >

          <el-upload
            action=""
            :fileList="upload.fileList"
            :limit="1"
            :http-request="uploadRequest"
            :autoUpload="true"
            :show-file-list="false"
          >
            <el-button :loading="upload.loading" type="primary">
              批量添加车辆
            </el-button>
          </el-upload>
        </div>
        <div class="tips">
          <p>请先批量添加车辆，需按下载模板导入</p>
          <p>批量导入规则：</p>
          <p>1.所添加车辆需为同一企业租赁主订单下的车辆</p>
          <p>2.批量操作续约的企业租赁子订单计租结束日/免租结束日需相同</p>
          <p class="mt-16">
            更多能力正在建设中，如您在使用过程中有优化建议或遇到问题，可通过页面右上角在线反馈入口<br />提交您的问题或建议，我们会在第一时间为您处理，感谢您对车务系统的支持与理解
          </p>
        </div>
      </div>

      <div v-if="orderDataList.length">
        <QS-h4-title title="企业租赁主订单信息" />
        <form-text-box
          :column="3"
          :dataList="orderInfo.list"
          :model="orderInfo.model"
        />

        <p class="total">共计{{ orderInfo.model.carTotalNum }}条</p>
        <QS-common-table
          :loading="tableLoading"
          :data="orderDataList"
          :columns="tableColumns"
          :pagination="pagination"
          @change="handlePaginationChange"
        />
      </div>

      <template slot="bottomAction">
        <div class="btn-group">
          <el-button @click="handleCancel">取消</el-button>
          <el-button
            type="primary"
            :disabled="!orderDataList.length"
            @click="handleNext"
            >下一步</el-button
          >
        </div>
      </template>
    </QS-scroller-box>
  </div>
</template>

<script>
import {
  batchUploadEnterpriseSubOrderRenewal,
  exportEnterpriseSubOrderRenewal,
  previewEnterpriseSubOrderRenewal,
  removeEnterpriseSubOrderRenewal,
  uploadFile,
} from '@/api/domain/underLease'
import { BATCH_UPLOAD_TEMPLATE_URL } from '../../config/orderBatchUpload'
import { mixin } from '../../mixins/orderBatchUpload'

export default {
  mixins: [mixin],
  data() {
    return {
      // 当前页的续约子订单
      orderDataList: [],
      // 全部的续约子订单
      allOrderDataList: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      upload: {
        fileList: [],
        loading: false,
      },
      tableLoading: false,
      previewId: '',
      deposit: {
        // eslint-disable-next-line vue/no-unused-properties
        flag: false, // 押金是否可平移
        // eslint-disable-next-line vue/no-unused-properties
        depositReceived: 0, // 已收押金金额
      },
    }
  },
  methods: {
    handleDownloadTemplate() {
      window.location.href = BATCH_UPLOAD_TEMPLATE_URL
    },
    handleCancel() {
      this.$confirm('是否确认取消订单续约？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$refreshBack(false)
          this.$router.replace({
            name: 'order_renewal',
          })
        })
        .catch(() => null)
    },
    handleNext() {
      this.$emit('completeOrderSelect', this.allOrderDataList)
    },
    handlePaginationChange({ pagination }) {
      const { pageSize, pageNum } = pagination
      this.pageSize = pageSize
      this.pageNum = pageNum
      this.previewEnterpriseSubOrderRenewal(this.previewId, pageNum, pageSize)
    },
    async uploadRequest({ file }) {
      this.upload.fileList = [file]
      this.upload.loading = true

      // 上传文件
      let res
      try {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('group', 'order')
        formData.append('code', 'order_renting_master_file')

        res = await uploadFile(formData)
      } catch (err) {
        this.upload.fileList = []
        this.upload.loading = false
      }

      if (!res) return

      // 创建异步解析任务
      const { code, data } = res
      if (code === 1 && data) {
        this.batchUploadEnterpriseSubOrderRenewal(data)
      } else {
        this.upload.fileList = []
        this.upload.loading = false
      }
    },
    // 创建异步导入任务
    async batchUploadEnterpriseSubOrderRenewal(fileAddress) {
      this.upload.fileList = []
      batchUploadEnterpriseSubOrderRenewal({
        fileAddress,
      }).then(({ code, data }) => {
        if (code === 1) {
          if (data.previewId) {
            this.previewId = data.previewId
            this.deposit = data.depositReceived
            this.orderInfo.model.entRentOrderId = data.entRentOrderId
            this.orderInfo.model.state = data.state
            this.orderInfo.model.contractStartDate = data.contractStartDate
            this.orderInfo.model.contractEndDate = data.contractEndDate
            this.orderInfo.model.carTotalNum = data.carTotalNum
            this.previewEnterpriseSubOrderRenewal(this.previewId, 1, 10)
          }

          if (data.address) {
            // this.errorFileAddress = data.address
            this.$confirm('上传失败，可下载失败列表查看详情', '提示', {
              confirmButtonText: '下载',
              cancelButtonText: '取消',
              type: 'error',
            })
              .then(() => {
                this.exportEnterpriseSubOrderRenewal(data.address)
              })
              .catch(() => null)
          }
        }
      }).finally(() => {
        this.upload.loading = false
      })
    },
    // 预览导入结果
    async previewEnterpriseSubOrderRenewal(previewId, pageNum, pageSize) {
      let res

      try {
        res = await previewEnterpriseSubOrderRenewal({
          previewId,
          pageNum,
          pageSize,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res
      if (code === 1) {
        this.orderDataList = data.items || []
        this.pagination.pageNum = data.pageNum
        this.pagination.pageSize = data.pageSize
        this.pagination.total = data.totalNum
        this.getAllEnterpriseSubOrderRenewal(this.previewId, 1, data.totalNum)
      }
    },
    // 获取所有需要续约的子订单
    async getAllEnterpriseSubOrderRenewal(previewId, pageNum, pageSize) {
      let res

      try {
        res = await previewEnterpriseSubOrderRenewal({
          previewId,
          pageNum,
          pageSize,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res
      if (code === 1) {
        this.allOrderDataList = data.items || []
        // 押金信息直接挂在allOrderDataList，方便租赁信息模块获取
        this.allOrderDataList.deposit = this.deposit
      }
    },
    errorDataToFile(data, fileName) {
      const url = window.URL.createObjectURL(
        new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
      )
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async exportEnterpriseSubOrderRenewal(fileAddress) {
      try {
        const data = await exportEnterpriseSubOrderRenewal({
          fileAddress,
        })

        if (data) {
          this.errorDataToFile(data, '批量导入失败列表')
        }
      } catch (err) {
        console.error(err)
      }
    },
    // 删除某条导入
    // mixins里有调用
    // eslint-disable-next-line vue/no-unused-properties
    async removeEnterpriseSubOrderRenewal(rentOrderId, previewId) {
      let res

      try {
        res = await removeEnterpriseSubOrderRenewal({
          rentOrderId,
          previewId,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code } = res
      if (code === 1) {
        this.previewEnterpriseSubOrderRenewal(
          this.previewId,
          this.pageNum,
          this.pageSize,
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  font-weight: 600;
  font-size: 16px;
  color: #323233;
  margin-bottom: 14px;
}
.btns {
  display: flex;
  margin-top: 16px;
  margin-left: 52px;
}
.download-template {
  margin-right: 12px;
}
.tips {
  margin-top: 16px;
  margin-left: 32px;
  margin-bottom: 32px;
}
.total {
  text-align: right;
}
.mt-16 {
  margin-top: 16px;
}
</style>
